/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type UserFragment = { __typename: 'UserType', id: string, createdAt: string, updatedAt: string, name: string, email: string, roles?: Array<string | null> | null };

export type UsersQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  userId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  userId_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['ID']['input']>> | Types.InputMaybe<Types.Scalars['ID']['input']>>;
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  name_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UsersQuery = { __typename: 'Query', users?: { __typename: 'UserTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'UserTypeEdge', node?: { __typename: 'UserType', id: string, createdAt: string, updatedAt: string, name: string, email: string, roles?: Array<string | null> | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type UserQueryVariables = Types.Exact<{
  userId: Types.Scalars['UUID']['input'];
}>;


export type UserQuery = { __typename: 'Query', user?: { __typename: 'UserType', id: string, createdAt: string, updatedAt: string, name: string, email: string, roles?: Array<string | null> | null } | null };

export type CurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename: 'Query', currentUser?: { __typename: 'UserType', id: string, createdAt: string, updatedAt: string, name: string, email: string, roles?: Array<string | null> | null } | null };

export type CreateUserMutationVariables = Types.Exact<{
  input: Types.CreateUserMutationInput;
}>;


export type CreateUserMutation = { __typename: 'Mutation', createUser?: { __typename: 'CreateUserMutation', user?: { __typename: 'UserType', id: string, createdAt: string, updatedAt: string, name: string, email: string, roles?: Array<string | null> | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type InviteUserMutationVariables = Types.Exact<{
  input: Types.InviteUserMutationInput;
}>;


export type InviteUserMutation = { __typename: 'Mutation', inviteUser?: { __typename: 'InviteUserMutation', user?: { __typename: 'UserType', id: string, createdAt: string, updatedAt: string, name: string, email: string, roles?: Array<string | null> | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type UpdateUserMutationVariables = Types.Exact<{
  input: Types.UpdateUserMutationInput;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', updateUser?: { __typename: 'UpdateUserMutation', user?: { __typename: 'UserType', id: string, createdAt: string, updatedAt: string, name: string, email: string, roles?: Array<string | null> | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type DeleteUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['UUID']['input'];
}>;


export type DeleteUserMutation = { __typename: 'Mutation', deleteUser?: { __typename: 'DeleteUserMutation', success?: boolean | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const UserFragmentDoc = new TypedDocumentString(`
    fragment User on UserType {
  id
  createdAt
  updatedAt
  name
  email
  roles
}
    `, {"fragmentName":"User"});
export const UsersDocument = new TypedDocumentString(`
    query Users($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $userId: ID, $userId_In: [ID], $name: String, $name_Icontains: String, $email: String, $email_Icontains: String, $sortBy: String) {
  users(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    id: $userId
    id_In: $userId_In
    name: $name
    name_Icontains: $name_Icontains
    email: $email
    email_Icontains: $email_Icontains
    sortBy: $sortBy
  ) {
    edges {
      node {
        ...User
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment User on UserType {
  id
  createdAt
  updatedAt
  name
  email
  roles
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);

export const useUsersQuery = <
      TData = UsersQuery,
      TError = unknown
    >(
      variables?: UsersQueryVariables,
      options?: Omit<UseQueryOptions<UsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Users'] : ['Users', variables],
    queryFn: fetcher<UsersQuery, UsersQueryVariables>(UsersDocument, variables),
    ...options
  }
    )};

useUsersQuery.getKey = (variables?: UsersQueryVariables) => variables === undefined ? ['Users'] : ['Users', variables];

export const useInfiniteUsersQuery = <
      TData = InfiniteData<UsersQuery>,
      TError = unknown
    >(
      variables: UsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Users.infinite'] : ['Users.infinite', variables],
      queryFn: (metaData) => fetcher<UsersQuery, UsersQueryVariables>(UsersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUsersQuery.getKey = (variables?: UsersQueryVariables) => variables === undefined ? ['Users.infinite'] : ['Users.infinite', variables];


useUsersQuery.fetcher = (variables?: UsersQueryVariables) => fetcher<UsersQuery, UsersQueryVariables>(UsersDocument, variables);

export const UserDocument = new TypedDocumentString(`
    query User($userId: UUID!) {
  user(id: $userId) {
    ...User
  }
}
    fragment User on UserType {
  id
  createdAt
  updatedAt
  name
  email
  roles
}`);

export const useUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      variables: UserQueryVariables,
      options?: Omit<UseQueryOptions<UserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserQuery, TError, TData>(
      {
    queryKey: ['User', variables],
    queryFn: fetcher<UserQuery, UserQueryVariables>(UserDocument, variables),
    ...options
  }
    )};

useUserQuery.getKey = (variables: UserQueryVariables) => ['User', variables];

export const useInfiniteUserQuery = <
      TData = InfiniteData<UserQuery>,
      TError = unknown
    >(
      variables: UserQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['User.infinite', variables],
      queryFn: (metaData) => fetcher<UserQuery, UserQueryVariables>(UserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserQuery.getKey = (variables: UserQueryVariables) => ['User.infinite', variables];


useUserQuery.fetcher = (variables: UserQueryVariables) => fetcher<UserQuery, UserQueryVariables>(UserDocument, variables);

export const CurrentUserDocument = new TypedDocumentString(`
    query CurrentUser {
  currentUser {
    ...User
  }
}
    fragment User on UserType {
  id
  createdAt
  updatedAt
  name
  email
  roles
}`);

export const useCurrentUserQuery = <
      TData = CurrentUserQuery,
      TError = unknown
    >(
      variables?: CurrentUserQueryVariables,
      options?: Omit<UseQueryOptions<CurrentUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CurrentUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CurrentUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables],
    queryFn: fetcher<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, variables),
    ...options
  }
    )};

useCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) => variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables];

export const useInfiniteCurrentUserQuery = <
      TData = InfiniteData<CurrentUserQuery>,
      TError = unknown
    >(
      variables: CurrentUserQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CurrentUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CurrentUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CurrentUserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CurrentUser.infinite'] : ['CurrentUser.infinite', variables],
      queryFn: (metaData) => fetcher<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) => variables === undefined ? ['CurrentUser.infinite'] : ['CurrentUser.infinite', variables];


useCurrentUserQuery.fetcher = (variables?: CurrentUserQueryVariables) => fetcher<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, variables);

export const CreateUserDocument = new TypedDocumentString(`
    mutation CreateUser($input: CreateUserMutationInput!) {
  createUser(input: $input) {
    user {
      ...User
    }
    errors {
      ...Error
    }
  }
}
    fragment User on UserType {
  id
  createdAt
  updatedAt
  name
  email
  roles
}
fragment Error on ErrorType {
  field
  message
}`);

export const useCreateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserMutation, TError, CreateUserMutationVariables, TContext>) => {
    
    return useMutation<CreateUserMutation, TError, CreateUserMutationVariables, TContext>(
      {
    mutationKey: ['CreateUser'],
    mutationFn: (variables?: CreateUserMutationVariables) => fetcher<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, variables)(),
    ...options
  }
    )};


useCreateUserMutation.fetcher = (variables: CreateUserMutationVariables) => fetcher<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, variables);

export const InviteUserDocument = new TypedDocumentString(`
    mutation InviteUser($input: InviteUserMutationInput!) {
  inviteUser(input: $input) {
    user {
      ...User
    }
    errors {
      ...Error
    }
  }
}
    fragment User on UserType {
  id
  createdAt
  updatedAt
  name
  email
  roles
}
fragment Error on ErrorType {
  field
  message
}`);

export const useInviteUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InviteUserMutation, TError, InviteUserMutationVariables, TContext>) => {
    
    return useMutation<InviteUserMutation, TError, InviteUserMutationVariables, TContext>(
      {
    mutationKey: ['InviteUser'],
    mutationFn: (variables?: InviteUserMutationVariables) => fetcher<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, variables)(),
    ...options
  }
    )};


useInviteUserMutation.fetcher = (variables: InviteUserMutationVariables) => fetcher<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, variables);

export const UpdateUserDocument = new TypedDocumentString(`
    mutation UpdateUser($input: UpdateUserMutationInput!) {
  updateUser(input: $input) {
    user {
      ...User
    }
    errors {
      ...Error
    }
  }
}
    fragment User on UserType {
  id
  createdAt
  updatedAt
  name
  email
  roles
}
fragment Error on ErrorType {
  field
  message
}`);

export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>) => {
    
    return useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUser'],
    mutationFn: (variables?: UpdateUserMutationVariables) => fetcher<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, variables)(),
    ...options
  }
    )};


useUpdateUserMutation.fetcher = (variables: UpdateUserMutationVariables) => fetcher<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, variables);

export const DeleteUserDocument = new TypedDocumentString(`
    mutation DeleteUser($userId: UUID!) {
  deleteUser(id: $userId) {
    success
    errors {
      ...Error
    }
  }
}
    fragment Error on ErrorType {
  field
  message
}`);

export const useDeleteUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>) => {
    
    return useMutation<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>(
      {
    mutationKey: ['DeleteUser'],
    mutationFn: (variables?: DeleteUserMutationVariables) => fetcher<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, variables)(),
    ...options
  }
    )};


useDeleteUserMutation.fetcher = (variables: DeleteUserMutationVariables) => fetcher<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, variables);
